var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, EventEmitter, HostListener, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../../../common/components/base.component';
import { HubEvent } from "../../../models/hub/hub.event";
import { VisitorApiService } from "../../../services/visitor.api.service";
import { ActivatedRoute } from "@angular/router";
import { VisitorDataCache } from "../../../stores/visitor.calendar.store";
var UpcomingEventsComponent = /** @class */ (function (_super) {
    __extends(UpcomingEventsComponent, _super);
    function UpcomingEventsComponent(activatedRoute, visitorApiService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.activatedRoute = activatedRoute;
        _this.visitorApiService = visitorApiService;
        _this.isLoadingUpcomingEvents = false;
        _this.column = 2;
        _this.onUpcomingEventClick = new EventEmitter();
        _this.onMoreClick = new EventEmitter();
        return _this;
    }
    UpcomingEventsComponent.prototype.ngOnInit = function () {
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.loadUpcomingEvents();
    };
    UpcomingEventsComponent.prototype.upcomingEventClick = function () {
        this.onUpcomingEventClick.emit();
    };
    UpcomingEventsComponent.prototype.more = function () {
        this.onMoreClick.emit();
    };
    UpcomingEventsComponent.prototype.loadUpcomingEvents = function () {
        var _this = this;
        // get the next 4 events, if localStorage has more than 4 events, load from it, otherwise load from server
        this.isLoadingUpcomingEvents = true;
        // let events = JSON.parse(localStorage.getItem(localStorageKeys.visitorEvents)) as HubEvent[];
        var events = VisitorDataCache.events;
        var fromIndex = events.findIndex(function (x) { return x._id === _this.currentEvent._id; }) + 1;
        if (fromIndex && fromIndex + 4 <= events.length) {
            this.upcomingEvents = events.slice(fromIndex, fromIndex + 4);
            this.isLoadingUpcomingEvents = false;
        }
        else {
            this.loadEventsFromServer();
        }
    };
    UpcomingEventsComponent.prototype.loadEventsFromServer = function () {
        var _this = this;
        this.visitorApiService
            .getEvents(this.hubName, { isForUpcoming: true, id: this.currentEvent._id })
            .subscribe(function (events) {
            _this.upcomingEvents = events.splice(1);
            _this.isLoadingUpcomingEvents = false;
        });
    };
    return UpcomingEventsComponent;
}(BaseComponent));
export { UpcomingEventsComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/upcoming.events/upcoming.events.component.ts.pre-build-optimizer.js